export default "__VITE_ASSET__YgfxTRek__"